import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueDraggable from 'vuedraggable';

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
      validate: options => Array.isArray(options) && options.length &&
        options.filter(o => o && o.text && o.value).length === options.length,
    },
    state: {
      type: Boolean,
      default: null,
    },
    value: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    checked: null,
    order: null,
  }),
  created() {
    this.checked = {};
    this.order = [];

    (Array.isArray(this.value) ? this.value : []).forEach(value => {
      this.checked[value] = true;
      this.order.push(value);
    });
    this.options.filter(o => o && o.value && !this.checked[o.value]).forEach(({ value }) => {
      this.checked[value] = false;
      this.order.push(value);
    });
  },
  render(el) {
    const buildInput = () => {
      const { checked, order } = this;
      const result = (checked && Array.isArray(order)) ? order.filter(value => checked[value] === true) : [];
      // this.$log.debug({ checked, order, result });
      return result;
    };

    const children = this.order.map(value => {
      const { id, text } = this.options.find(o => o && o.value === value) || {};
      const { [id ? `${id}-label` : null]: textSlot } = this.$scopedSlots;

      return el('b-input-group', {
        key: value,
        scopedSlots: {
          prepend: () => el(FontAwesomeIcon, {
            class: 'checkbox-ordered m-2',
            props: { icon: 'bars' },
          }),
        },
      }, [
        el('b-form-checkbox', {
          props: {
            checked: this.checked[value],
            disabled: this.disabled || false,
            state: typeof this.state === 'boolean' ? this.state : null,
            switch: true,
          },
          attrs: { id },
          on: {
            input: checked => {
              this.checked[value] = checked;
              this.$emit('input', buildInput());
            },
          },
        }, [ typeof textSlot === 'function' ? textSlot({ text }) : text ]),
      ]);
    });

    return el(VueDraggable, {
      props: {
        disabled: this.disabled || false,
        draggable: '.checkbox-ordered',
        value: this.order,
      },
      on: {
        input: newOrder => {
          this.order = newOrder;
          this.$emit('input', buildInput());
        },
      },
    }, children);
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/OrderedCheckboxGroup.js